import React from 'react';
const Footer = () => (
  <>
   <footer className="footer">
        <div className="top">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <div className="item">
                             <a href="/" aria-label="Residency Group Hotels Home">

                  <img
                    src="img/logo.webp"
                    className="img-fluid"
                    alt="Residency Group Hotels Logo"
                    width="180"
                    height="80"
                    loading="lazy"
                    decoding="async"
                  />

                </a>
                        </div>
                    </div>
                        <div className="col-md-3 offset-1">
                        <div className="item">
                            <h3>Quick Links</h3>
                           <ul className="footer-explore-list list-unstyled">

                  <li>
                    <a href="/" aria-label="Home Page">
                      Home
                    </a>
                  </li>

                  <li>
                    <a href="/about-us" aria-label="About Us Page">
                      About Us
                    </a>
                  </li>

                  <li>
                    <a href="/contact-us" aria-label="Contact Us Page">
                      Contact Us
                    </a>
                  </li>

                </ul>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="item">
                            <h3>Get in touch</h3>
                           <ul className="footer-explore-list list-unstyled">

                  <li>
                    <a href="/hotels" aria-label="Hotels">
                      Hotels
                    </a>
                  </li>

                  <li>
                    <a href="/events" aria-label="Events">
                      Events
                    </a>
                  </li>

                </ul>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="item">
                            <h3>Connect Us</h3>
                            <div className="social mt-3">

                  <a
                    href="https://www.facebook.com/p/Residency-Group-Hotels-100076310318273/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit Facebook Page"
                  >
                    <i className="ti-facebook"></i>
                  </a>

                  <a
                    href="https://www.instagram.com/residencygrouphotels/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit Instagram Page"
                  >
                    <i className="ti-instagram"></i>
                  </a>

                </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="bottom">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 mb-3">
                          <p>
                © 2026 Residency Group Hotels. All Rights Reserved.
              </p>
                    </div>
                    <div className="col-lg-6 col-md-6">
                         <p>
                Powered By{" "}
                <a
                  href="https://www.transindiatechnologies.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Trans India Technologies Website"
                >
                  Trans India Technologies
                </a>
              </p>
                        </div>

                </div>
            </div>
        </div>
    </footer>
  </>
);

export default Footer;
